@if (showLoader) {
  <div class="loading-container">
    <app-loading></app-loading>
  </div>
}
<div class="close-button-container">
  <mat-icon class="close-button mat-icon" aria-hidden="true" data-mat-icon-type="font" (click)="closeDialog()"
    >close</mat-icon
  >
</div>
@if (!showLoader) {
  <h2 class="social-dialog-title" mat-dialog-title>
    {{ data.modalTitle }}
  </h2>
}
@if (!showLoader) {
  <mat-dialog-content>
    <div class="text-center">
      <mat-form-field>
        <mat-label>Music Playlist</mat-label>
        <mat-select id="cbo-room-room-music" [formControl]="playlist" panelClass="playlist-select-panel">
          <mat-select-trigger>{{ playlistSelectedName }}</mat-select-trigger>
          @for (option of playlistOptions; track option) {
            <mat-option
              [id]="'playlist-' + option.playlistId"
              [value]="option.playlistId"
              [disabled]="option.type === 1 && !option.available"
            >
              @if (option.type === 1 && option.available) {
                <mat-icon class="premium" matTooltip="Premium Playlist" svgIcon="playlist_premium"></mat-icon>
              }
              @if (option.type === 1 && !option.available) {
                <mat-icon
                  class="premium-locked"
                  matTooltip="This is a Premium playlist. Contact support@scoot.app to access this."
                  >lock</mat-icon
                >
              }
              @if (!option.type) {
                <mat-icon class="non-premium" matTooltip="Standard Playlist">album</mat-icon>
              }
              {{ option.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="text-center">
      @if (data.primaryButtonText) {
        <button
          id="btnUpdateRoomPlaylist"
          mat-raised-button
          (click)="updatePlaylist()"
          class="social-modal-buttons social-modal-button-primary"
        >
          {{ data.primaryButtonText }}
        </button>
      }
    </div>
  </mat-dialog-content>
}
